// Regular expression for invalid characters in file names
export const INVALID_FILENAME_CHARS = /[\\/:*?"<>|]/g;

/**
 * Replaces invalid characters in file name with underscores
 * @param fileName The file name to clean
 * @returns The cleaned file name with invalid characters replaced by underscores
 */
export function sanitizeFileName(fileName: string): string {
  return fileName.replace(INVALID_FILENAME_CHARS, '_');
}
